import React from 'react';
import cx from 'classnames';

import { scrollToEl } from '../../internals/react-utils';

import type { Needle } from '../../types/commandPalette.types';

import { TestID } from '../../testID';

export const Result: React.FC<{
  needle: Needle;
  onClick: (n: Needle) => (ev: React.MouseEvent<HTMLLIElement>) => void;
  selected: boolean;
}> = ({ needle, onClick, selected }) => {
  const resClass = 'command-palette__result';
  const selClass = 'command-palette__result--selected';

  return (
    <li
      className={cx(resClass, selected && selClass)}
      onClick={onClick(needle)}
      ref={(el) => {
        if (selected && el) {
          scrollToEl(el);
        }
      }}
      key={needle.keyMaker(needle.item.id)}
      data-testid={TestID.CommandPaletteSearchResultRow}
    >
      {needle.renderer({
        id: needle.item.id,
        name: needle.item?.name,
        type: needle.type,
      })}
    </li>
  );
};

export const ResultsList: React.FC<{
  results: Needle[];
  handleNeedleClick: (needle: Needle) => (ev: React.MouseEvent<HTMLLIElement>) => void;
  selIdx: number;
}> = ({ results, handleNeedleClick, selIdx }) => (
  <ul className="command-palette__results">
    {results.map((needle, idx) => (
      <Result needle={needle} onClick={handleNeedleClick} selected={idx === selIdx} key={idx} />
    ))}
  </ul>
);
